import { Meta } from "@/shared/components";
import { Configs } from "@/admin/features/configs";

export function ConfigsPage() {
  return (
    <>
      <Meta title="Конфиги" />
      <Configs />
    </>
  );
}
